module.exports = __webpack_public_path__ + "img/crew_adv_03.e6a192f0.png";